<div class="modal-header">
	<h1 class="modal-title">{{ title }}</h1>
	<button
		class="btn btn-outline-dark"
		id="role.edit.modal.component.times.close"
		title="Close"
		type="button"
		(click)="activeModal.dismiss()"
	>
		<i aria-hidden="true" class="far fa-times"></i>
	</button>
</div>

<div class="modal-body">
	<div *aeSpinWhile="loading" class="form-group">
		<div class="fw-bold">{{ item.name }}</div>
		<ng-select
			bindLabel="title"
			bindValue="key"
			class="role-edit-select"
			[formControl]="selectCtrl"
			[items]="roleOptions"
			[multiple]="true"
		>
			<ng-template let-item="item" ng-label-tmp>
				<div
					class="role-option-label"
					container="body"
					triggers="mouseenter:mouseleave"
					[ngClass]="{
						'disabled-option': item.disabled,
					}"
					[ngbTooltip]="getInstituteRoleTooltip(item.key) || null"
				>
					@if (!item.disabled) {
						<button
							aria-label="Remove role"
							class="role-label-close-btn border-0 ms-1"
							type="button"
							(click)="removeSelectedRole(item.key, $event)"
						>
							&times;
						</button>
					}
					<span class="p-1">{{ item.title }}</span>
				</div>
			</ng-template>
		</ng-select>
	</div>
</div>
<div class="modal-footer">
	<button
		class="btn btn-secondary"
		id="role.edit.modal.component.cancel"
		type="button"
		(click)="activeModal.dismiss()"
	>
		Cancel
	</button>
	<button
		class="btn btn-primary"
		id="role.edit.modal.component.save"
		type="button"
		[disabled]="loading || !selectCtrl.valid || !selectCtrl.dirty"
		(click)="save()"
	>
		Save
	</button>
</div>
